import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { SessionProvider } from "./auth/SessionProvider";
import "./i18n"; // initialise i18next avant le premier rendu
import "./styles.css";

const container = document.getElementById("root");
if (container === null) {
  throw new Error("Element #root introuvable dans index.html");
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <App />
      </SessionProvider>
    </BrowserRouter>
  </StrictMode>,
);
